/* eslint-disable no-underscore-dangle */

'use strict';

const onOptionUpdate = ({ optionsMsrpHash }) => {
  const msrpLabel = document.querySelector('.source-metadata-label');

  window.DealEventPipe.on(
    'goodsOptionUpdate',
    ({ hideOriginalPriceAndDiscount, uuid }) => {
      const optionMsrp = optionsMsrpHash[uuid];
      if (hideOriginalPriceAndDiscount || !optionMsrp) {
        msrpLabel.innerHTML = '';
        msrpLabel.style.display = 'none';
        if (msrpLabel._tippy) {
          msrpLabel._tippy.setContent('');
          msrpLabel._tippy.disable();
        }
      } else if (optionMsrp) {
        const { description, label } = optionMsrp;
        msrpLabel.innerHTML = label;
        if (msrpLabel._tippy) {
          msrpLabel._tippy.setContent(description);
          msrpLabel._tippy.enable();
        }
      }
    }
  );
};

const MSRP = {
  init({ msrp }, done) {
    if (!msrp) {
      return done();
    }

    onOptionUpdate(msrp);

    return done();
  },
};

module.exports = MSRP;
